import React, { useState, useEffect, useContext } from 'react';
import {observer} from "mobx-react";

import * as net from "../../lib/net";
import ddo from "../../ddo";

import Art_Edit from "./fkn/art_edit";

function web01() {

    var html =
        <h4>Huvud</h4>
    ;
    return html;
}

class Lag_Art extends React.Component {
  constructor(props, context) {
    super(props);

    this.webStore = props.store;
    this.pos = props.store.pos;

    this.state = { pgid: 11, tra: [] };
    this.state.seldate = new Date();
    this.state.avd = "01";
    this.state.arts = [];
    this.state.aa = [];
    this.state.wnds = {};
    if(this.pos.deps) this.state.aa = this.pos.deps;
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
    this.arts();
  }

  body_style() {
      var css = {};
      css.height = window.innerHeight - 280;
      return css;
  }
  tb_style() {
      var css = {};
      css.height = window.innerHeight - 280;
      return css;
  }
  onUnitChange(e) {
        this.setState({unit: e.value});
  }

  art_edit(row) {
    var self = this;
    //alert(JSON.stringify(row.bet00));
    //var bto = JSON.parse(JSON.stringify(row.bet00));
    var wnds = {};
    wnds.artedit = true;
    wnds.art = row;
    wnds.backdrop = true;
    self.setState({wnds: wnds });
  }

  arts() {
    var self = this;
    var prm = {};
    prm.req = "pos.pos_art.arts";
    prm.avd = this.state.avd;

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rca));

        self.setState({arts: ret.rco });
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
  }
  change_avd(e) {
    //let cdat = this.state.seldate;
    let avd = e.target.value;
    this.setState({avd: avd});
  }

  render() {
    return (
    <div className="web-app">

    <div className="flex-row">
        <select className="form-control w250" value={this.state.avd} placeholder="Välj avdelning" onChange={(e) => this.change_avd(e)}>
            { this.props.store.pos.deps.map((row, key) =>
            <option key={key} value={row.avd}>{row.avd} - {row.text}</option>
            )}
        </select>
        <div className="flex"></div>

        <button className="btn btn-hw-blue w150" onClick={() => this.vgrps() } aria-label="System" >
            Visa
        </button>
    </div>
    <div className="divider_orange"></div>

    <div className="web-row">
        <table className="table table-bordered table-hover tb fixed_header">
            <thead>
            <tr>
                <th>ArtID</th>
                <th>Text</th>
                <th>Pris</th>
                <th>Moms</th>
                <th>Sort</th>
                <th>Lag Ant</th>
                <th>Lag Ställe</th>
                <th>Lev</th>
                <th></th>
            </tr>
            </thead>
            <tbody style={ this.tb_style() }>
            { this.state.arts.map((row, key) =>
            <tr key={key} onDoubleClick={() => this.art_edit(row) }>
                <td>{ row.art00.a0katnr }</td>
                <td>{ row.art00.a0namn.toswe() }</td>
                <td>{ row.art00.a0pris }</td>
                <td>{ row.art00.a0moms }</td>
                <td>{ row.art00.a0sort }</td>
                <td>{ row.art00.a0lagant }</td>
                <td>{ row.art00.a0lagst }</td>
                <td>{ row.art00.a0lev }</td>
                <td onClick={() => this.art_edit(row) }><i className="fa fa-cog text-danger"></i></td>
            </tr>
            )}
            </tbody>
        </table>
    </div>

    { this.state.wnds.artedit ? <Art_Edit wnds={ this.state.wnds } ctx={this} store={this.props.store} backdrop={true}/> : null }
    </div>
  );
    }
}
export default observer(Lag_Art);
